import { SENSITIVE_KEYS } from './serialize'

const SENSITIVE = new Set(SENSITIVE_KEYS.map((key) => key.toLowerCase()))

export function isPlainObject(value: unknown): value is Record<string, unknown> {
  if (typeof value !== 'object' || value === null) {
    return false
  }
  const prototype: unknown = Object.getPrototypeOf(value)
  return prototype === Object.prototype || prototype === null
}

// walks every depth; `ancestors` holds the current path so a shared object is copied twice and only a
// real cycle becomes '[Circular]'
function redactValue(value: unknown, ancestors: WeakSet<object>): unknown {
  if (!Array.isArray(value) && !isPlainObject(value)) {
    return value
  }
  if (ancestors.has(value)) {
    return '[Circular]'
  }
  ancestors.add(value)
  try {
    if (Array.isArray(value)) {
      return value.map((item: unknown) => redactValue(item, ancestors))
    }
    return Object.fromEntries(
      Object.entries(value).map(([key, item]) => [
        key,
        SENSITIVE.has(key.toLowerCase()) ? '[Redacted]' : redactValue(item, ancestors),
      ]),
    )
  } finally {
    ancestors.delete(value)
  }
}

// a copy with every SENSITIVE_KEYS key censored at any depth, matched case-insensitively
export function redactFields(fields: Record<string, unknown>): Record<string, unknown> {
  const redacted = redactValue(fields, new WeakSet())
  return isPlainObject(redacted) ? redacted : {}
}
